import axios from 'axios';
import { UtilS } from '../../../../../../../modules/Util/S/Function/module/UtilS';
import { debounceWithFirstCall } from '@services/MarppleShop/shared/util';

export class BecomeFanButtonController {
  public static postLike = debounceWithFirstCall(
    async (
      { is_liked, store_id }: { is_liked: boolean; store_id: number },
      errHandling: (e: unknown) => void,
    ) => {
      const already_like = !is_liked;
      try {
        await axios.post(UtilS.makeApiUrl(`/:lang/@api/stores_like`, { lang: T.lang }), {
          already_like,
          store_id,
        });
      } catch (e) {
        errHandling(e);
      }
    },
    500,
  );
}
